import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';
import { CohortMetadata } from 'schemas/metadata/cohorts.ts';

export interface CohortResponse {
  message: string;
  cohorts: {
    META: {
      Timestamp: string;
    };
    CohortRefData: CohortMetadata[];
  };
}

interface IFetchAllCohortsVariables {
  teamId: string;
}

export default function useFetchAllCohorts({ teamId }: IFetchAllCohortsVariables) {
  const { tokens } = useAuth();
  return useQuery({
    queryKey: ['allCohorts', { teamId }],
    queryFn: () => apiFetch<CohortResponse>({
      path: `team/${teamId}/allCohorts`,
      method: 'GET',
      accessToken: String(tokens.accessToken),
    }),
    enabled: Boolean(teamId),
  });
}
